<template>
    <TotemDatepicker
        :label="placeholder"
        ref="datepicker"
        :class="`${$totemLang}-${filterKey}`"
        v-model="selectedValue"
        :disabledDates="getDisabledDateSettings"
    />
</template>

<script>
    import moment from 'moment'
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'

    export default {
        name: 'reporting-date-picker-filter',
        mixins: [ filteringHelper ],
        inject: ['tab'],
        props: {
            translationString: {
                type: String,
                required: true
            },
            filterKey: {
                type: String,
                required: true
            },
            initialValue: {
                type: String,
                required: true
            }
        },
        computed: {
            placeholder () {
                return this.$t(this.translationString)
            },
            currentFilter () {
                return this.filtersWithKey(this.filterKey)
            },
            selectedValue: {
                get () {
                    const filterValues = this.filtersWithKey(this.filterKey)
                    const filterValueObject = filterValues[filterValues.length - 1]

                    if (filterValueObject === undefined) {
                        this.$store.dispatch(this.getAddFilterValueRoute, {
                            label: this.formattedDate(this.initialValue),
                            value: this.formattedDate(this.initialValue),
                            key: this.filterKey
                        })
                        return this.initialValue
                    }

                    return filterValueObject?.value
                },
                set (value) {
                    this.$store.dispatch(this.getAddFilterValueRoute, {
                        label: this.formattedDate(value),
                        value: this.formattedDate(value),
                        key: this.filterKey
                    })
                }
            },
            // eslint-disable-next-line vue/return-in-computed-property
            getDisabledDateSettings () {
                let startDate = moment(this.filters.startDate[0]?.value).add(1, 'days').format()
                let endDate = moment(this.filters.endDate[0]?.value).format()

                if (this.filterKey === 'startDate') {
                    return {
                        from: new Date(endDate)
                    }
                }

                if (this.filterKey === 'endDate') {
                    return {
                        from: new Date(),
                        to: new Date(startDate)
                    }
                }
            }
        },
        watch: {
            currentFilter (val) {
                if ((Array.isArray(val) && val.length === 0) || !val) {
                    return this.clearWithoutEmit()
                }
            }
        },
        methods: {
            clear () {
                if (this.$refs.datepicker) {
                    this.$refs.datepicker.clear()
                }
            },
            clearWithoutEmit () {
                if (this.$refs.datepicker) {
                    this.$refs.datepicker.clearWithoutEmit()
                }
            },
            formattedDate (date) {
                return moment(date).format('YYYY-MM-DD')
            }
        }
    }
</script>
